import React,{Component} from 'react';
import { firebaseAuth,ref } from '../config/constants'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';


class EditProduct extends Component{
    constructor(){
        super();
        
        this.handleChange = this.handleChange.bind(this);
        this.updateProduct = this.updateProduct.bind(this);
        this.cancelUpdate = this.cancelUpdate.bind(this);

        this.state ={
         userId : "",
         user : {},
         editProduct : {},
         unitsList : {},
         categoryList : {}
        }
    }

    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                db.on("value",function(data){

                    this.setState({
                    userId:data.key,
                    user:data.val()
                    });

                }.bind(this));
                
                var dbEdit = ref.child("Products").child(this.props.match.params.pid);
                dbEdit.on("value",function(data){             
                    this.setState({
                        editProduct : data.val()
                    });

                }.bind(this));
            }else{
                this.props.history.push("/");
            }
        });

        var units = ref.child("Units")
            units.on("value", function(snap){
                this.setState({
                    unitsList : snap.val()
                })
            }.bind(this))

        var cat = ref.child("Categories")
            cat.on("value", function(snap){
                this.setState({
                    categoryList : snap.val()
                })
            }.bind(this))  
    } 
  

    componentWillUnmount(){
      this.listener()
    }

    updateProduct(e){
        e.preventDefault();

        const updatedProduct=this.state.editProduct
        ref.child("Products").child(this.props.match.params.pid).update(updatedProduct).then(()=>{
        alert("product updated successfully")
        this.props.history.push("/products");
        });
    }

    handleChange(e){
        let updateProduct = this.state.editProduct;
        let update ={
            ...updateProduct,
            [e.target.name]:e.target.value
        } 
        this.setState({editProduct:update})       
    }

    cancelUpdate(){
        if (window.confirm("Do you want to cancel updating this product?") === true){
            this.props.history.push("/products");
        }else{
            alert("make updates to the product")
        }
    }  

    render() {
       
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Update Product" />
                            <div className="block">
                                <div className="block-title">
                                    <h2><i className="fa fa-pencil"></i> <strong>Product</strong> Information</h2>
                                </div>
                                <form className="form-horizontal form-bordered" onSubmit={this.updateProduct}>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Name</label>
                                        <div className="col-md-4">
                                            <input name="name" className="form-control" value={this.state.editProduct.name} type="text" onChange={this.handleChange} />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Category</label>
                                        <div className="col-md-4">
                                            <select id="product-category" name="category" value={this.state.editProduct.category} className="form-control" onChange={this.handleChange} >
                                                
                                               {                                               

                                                    Object.keys(this.state.categoryList).map(function (key){
                                                        let list = this.state.categoryList[key]
                                                        return <option value={list.category} key={key}> {list.category} </option>
                                                    }.bind(this))
                                                        
                                                }
                                                    
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Unit</label>
                                        <div className="col-md-4">
                                            <select id="product-unit" name="unit" value={this.state.editProduct.unit} className="form-control" onChange={this.handleChange}>
                                                
                                                { 
                                                    Object.keys(this.state.unitsList).map(function (key){
                                                        let list = this.state.unitsList[key]
                                                        return <option value={list.unit} key={key}> {list.unit} </option>
                                                    }.bind(this))
                                                        
                                                }

                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Dimension for Main Product </label>                                        
                                            <div className="col-md-4">                                                
                                                <input className="form-control" name="dimension" value={this.state.editProduct.dimension} type="text" onChange={this.handleChange}/>
                                            </div>                                        
                                    </div>
                                    <div className="row">
                                        <div className="col-md-1">
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-6 control-label" htmlFor="product-id">Product Price (0.4MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input name="price_4MM" className="form-control" value={this.state.editProduct.price_4MM} type="text" onChange={this.handleChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-4 control-label" htmlFor="product-id">Labor Price (0.4MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input className="form-control" name="laborPrice_4MM" value={this.state.editProduct.laborPrice_4MM} type="text" required onChange={this.handleChange}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-1">
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-6 control-label" htmlFor="product-id">Product Price (0.5MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input name="price_5MM" className="form-control" value={this.state.editProduct.price_5MM} type="text" onChange={this.handleChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-4 control-label" htmlFor="product-id">Labor Price (0.5MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input className="form-control" name="laborPrice_5MM" value={this.state.editProduct.laborPrice_5MM} type="text" required onChange={this.handleChange}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-1">
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-6 control-label" htmlFor="product-id">Product Price (0.6MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input name="price_6MM" className="form-control" value={this.state.editProduct.price_6MM} type="text" onChange={this.handleChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-4 control-label" htmlFor="product-id">Labor Price (0.6MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input className="form-control" name="laborPrice_6MM" value={this.state.editProduct.laborPrice_6MM} type="text" required onChange={this.handleChange}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-1">
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-6 control-label" htmlFor="product-id">Product Price (0.8MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input name="price_8MM" className="form-control" value={this.state.editProduct.price_8MM} type="text" onChange={this.handleChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 form-group">
                                            <label className="col-md-4 control-label" htmlFor="product-id">Labor Price (.8MM)</label>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                    <input className="form-control" name="laborPrice_8MM" value={this.state.editProduct.laborPrice_8MM} type="text" required onChange={this.handleChange}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Description</label>
                                        <div className="col-md-6">
                                            <textarea name="desc" className="form-control" rows="3" value={this.state.editProduct.desc}  onChange={this.handleChange}></textarea>
                                        </div>
                                    </div>

                                    <div className="form-group form-actions">
                                        <div className="col-md-9 col-md-offset-3">
                                            <button type="submit" className="btn btn-sm btn-primary" onClick={this.updateProduct}><i className="fa fa-floppy-o"></i> Update Product</button> 
                                            <button type="reset" className="btn btn-sm btn-warning" onClick={this.cancelUpdate}><i className="fa fa-repeat"></i> Reset</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>

        );
    }
}

export default  EditProduct;



// WEBPACK FOOTER //
// ./src/components/EditProduct.js